import React, { useEffect, useState } from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  Label,
  FormGroup,
  Form,
  Input,
  Button,
  Row,
  Col
} from 'reactstrap';
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { useHistory, useParams } from 'react-router-dom';
import { translate } from "react-translate";
import { DndContext } from '@dnd-kit/core';
import { 
  actionGetAvailableAssets,
 } from 'store/actions/assetsActions';
import { 
  actionKitSubmitForm, 
  actionKitSubmitEdition, 
  actionGetKitTypes, 
  actionSetEditKit,
  actionGetKit
} from 'store/actions/kitsActions';
import { actionSetRemoteKitEditorStatus } from 'store/actions/managementUserActions';
import AvailableAssetDraggable from './AvailableAssetDraggable';
import ReservedAssetList from './ReservedAssetList';

const KitsForm = (props) => {
    const dispatch = useDispatch();
    const { t } = props;
    const { id } = useParams();
    const assetIDPrefix = "av-";

    const [loading, setloading] = useState(false);
    const [loadingLocal, setloadingLocal] = useState(false);
    const [_page, setPage] = useState(0);
    const [_limit, setLimit] = useState(10);
    const [totalPage, setTotalPage] = useState(0);
    const [filter, setFilter] = useState(null);

    const { kitEdit } = useSelector(state => state.kitsReducer);
    const kitTypes = useSelector(state => state.kitsReducer.types);
    const { is_creating_kits } = useSelector(state => state.managementUserReducer);

    const { data, page, lastPage, limit } = useSelector(state => state.assetsReducer.availableAssets);

    const [availableAssetList, setAvailableAssetList] = useState(data && data.length ? data : []);
    const [reservedAssets, setreservedAssets] = useState(kitEdit.assets && kitEdit.assets.length ? kitEdit.assets : []);
    const [localAssets, saveLocalAsset] = useState([]);

    const [typeFilter, setTypeFilter] = useState(Object.keys(kitEdit).length ? kitEdit.type : Object.keys(kitTypes).length ? kitTypes[Object.keys(kitTypes)[0]] : null);

    const handleDragEnd = (e) => {
        if (e.over && e.over.id === "droppable") {
            reserveAsset(e.active.id.replace(assetIDPrefix, ""));
        }
    }

    //Assign asset to droppable zone
    const reserveAsset = (assetId) => {
      //Edge case for pagination
      let currentPage = _page;
      if (totalPage > 1 && _page+1 >= totalPage) {
        currentPage = _page-1;
      }

      //Check if the asset exists in the reserved list, to avoid adding it twice
      const asset = availableAssetList.find(a => a._id === assetId);
      if (reservedAssets.lenght && reservedAssets.find(a => a._id === asset._id)) {
        return;
      }

      setreservedAssets([...reservedAssets, asset]);
      setAvailableAssetList(availableAssetList.filter(a => a._id !== assetId));
      //dispatch(actionMarkAssetAsReserved(assetId, currentPage, _limit, filter));
    }

    //Unassign asset from droppable zone
    const unreserveAsset = (assetId) => {
      if (reservedAssets.length > 0 && availableAssetList.length < _limit) {
        const asset = reservedAssets.find(a => a._id === assetId);

        //If the asset is unreserved, but it was reserved before, add it
        if (asset && asset.status !== "a_st_available" && !localAssets.find(a => a._id === asset._id)) {
          saveLocalAsset([...localAssets, asset]);
        }

        //If asset matches current type filters, add it
        if (!asset.study_type || asset.study_type === typeFilter) {
          setAvailableAssetList([...availableAssetList, asset]);
        }
      }
      
      setreservedAssets(reservedAssets.filter(a => a._id !== assetId));
      //dispatch(actionMarkAssetAsAvailable(assetId, _page, _limit, filter));
    }
  
  const { register, handleSubmit } = useForm({
    defaultValues: {
      type: kitEdit.type,
      name: kitEdit.name
    }
  });
  const history = useHistory();

  const onSubmit = (data) => {

    if (!data.type.length) {
      return;
    }

    const kitData = {
        ...data,
        assets: reservedAssets.map(a => a._id)
    }
    
    if (Object.keys(kitEdit).length) {
      //Edit kit
      dispatch(actionKitSubmitEdition({...kitData, kitId: kitEdit._id}));
    } else {
      //Create new kit
      dispatch(actionKitSubmitForm(kitData));
    }
  };

  useEffect(() => {

    if (is_creating_kits) {
      history.goBack();
    } else {
      dispatch(actionSetRemoteKitEditorStatus(true));
    }

    if (!Object.keys(kitEdit).length && id) {
      dispatch(actionGetKit(id));
    }

    if (!Object.keys(kitTypes).length) {
      dispatch(actionGetKitTypes());
    }

    return () => {
      dispatch(actionSetRemoteKitEditorStatus(false));
      dispatch(actionSetEditKit({}));
    }
  }, []);

  useEffect(() => {
      if (data) {
        const filteredData = data.filter(a => {
          let pass = true;
          for (let ra of reservedAssets) {
            if (a._id === ra._id) {
              pass = false;
              break;
            }
          }
          return pass;
        });

        setloadingLocal(false);
        setPage(page);
        setLimit(limit);
        setTotalPage(lastPage);

        if (localAssets.length && filteredData.length < _limit) {
          //Add local assets saved during edition
          let filteredLocalList = localAssets.filter(a => {
            return !filteredData.find(fd => fd._id === a._id) && a.study_type === typeFilter
          });

          setAvailableAssetList([...filteredData, ...filteredLocalList ]);
        } else {
          //Set new asset list
          setAvailableAssetList(filteredData);
        }
      }
  }, [dispatch, data]);

  useEffect(() => {

    if (!typeFilter) {
      setTypeFilter(Object.keys(kitTypes)[0]);
    } else {
      dispatch(actionGetAvailableAssets(_page, _limit, filter, typeFilter));
    }
  }, [typeFilter, kitTypes]);

  useEffect(() => {
    //Change fields only if there is an ID param present
    if (Object.keys(kitEdit).length && id) {
      setreservedAssets(kitEdit.assets);
      setTypeFilter(kitEdit.type);
      const typeDropdown = document.getElementById("type");
      typeDropdown.value = kitEdit.type;
      typeDropdown.dispatchEvent(new Event("change"));
    }
  }, [kitEdit, kitTypes]);

  //method called by paginator and search
    const changeDataSearch = (page, filter) => {
        //if the search type "" refresh all data
        setloadingLocal(true)
        if (typeFilter) {
          if (filter == null) {
              setFilter(null);
              dispatch(actionGetAvailableAssets(page, _limit, null, typeFilter));
          } else {
              //we save search input text, therefore we will only paginate the search results
              setFilter(filter);
              dispatch(actionGetAvailableAssets(page, _limit, filter, typeFilter));
          }
        }
    }

  return (
    <div className="content user-manual-edit mt-3">

      <Card>
        <CardHeader><h6>{Object.keys(kitEdit).length ? `Editing kit ${kitEdit.friendly_id}` : "New kit"}</h6></CardHeader>
        <CardBody className="big-form">

        <Form id="kit-form" onSubmit={handleSubmit(onSubmit)}>
           <FormGroup>

            <Row>
              <Col>
                <Label for="type">{t("type")}</Label>
                <Input 
                  className={""}
                  type="select" 
                  name="type" 
                  id="type"
                  disabled={reservedAssets.length > 0}
                  onChange={(e) => {setTypeFilter(e.target.value)}}
                  innerRef={register}
                >
                  {Object.keys(kitTypes).map((t,i) => {
                    return <option selected={typeFilter === t} key={`type-${i}`} value={kitTypes[t]}>{kitTypes[t]}</option>
                  })}
                </Input>
              </Col>

              <Col>
                <Label for="status">{t("status")}</Label>
                <Input 
                  className={""}
                  type="select" 
                  name="status" 
                  id="status"
                  innerRef={register}
                >
                  <option value={"k_st_ready"}>{t("k_st_ready")}</option>
                  <option value={"k_st_assembling"}>{t("k_st_assembling")}</option>
                </Input>
              </Col>
            </Row>

            <br/>
            <Row>
              <DndContext className="" onDragEnd={handleDragEnd}>
                
                <AvailableAssetDraggable 
                  t={t}
                  draggableIDPrefix={assetIDPrefix} 
                  changeDataSearch={changeDataSearch} 
                  data={availableAssetList} 
                  page={_page} 
                  totalPage={totalPage}
                />

                <ReservedAssetList 
                  t={t}
                  unreserveAsset={unreserveAsset} 
                  reservedAssets={reservedAssets}
                />
                  
              </DndContext>

            </Row>
          </FormGroup>

        </Form>

          <Button form="kit-form" size="sm" color="info" type="submit">
            {kitEdit ? t("update-btn") : t("save-btn")}
          </Button>

          <Button
            form="kit-form"
            size="sm"
            color="danger"
            type="reset"
            onClick={(e) => {
              e.preventDefault();
              history.goBack();
            }}
          >
            {t("cancel-btn")}
          </Button>
        </CardBody>
      </Card>
    </div>
  );
};

export default translate("kits")(KitsForm);
